import {JourneyTrack} from '../journey-track';
import {TrackInfo} from '../model/track-info';
import {TrackTypes} from '../model/track-types';
import {DomainOrigin} from "../../../domains/model/domain-origin";
import {TrackActionResult} from "../model/track-action-result";
import {DataOrigin} from "../../../../model/DataOrigin";
import {environment} from "../../../../../../environments/environment";
import {ContaIonDataParse} from "./util/conta-ion-data-parse";
import {CacheService} from "../../../comunicator-native/cache/v2/cache.service";
import {MobileMockData} from "./util/mobile-mock-data";
import { Platform } from '@ionic/angular';

export class ContaIonAddressTrack extends JourneyTrack {

    readonly originalTracks = [
        
        new TrackInfo('cep', ['address', 'cep'],
            undefined, {dataOrigin: DataOrigin[environment.contaIonDataOrigin]}),
            new TrackInfo('address-completed', ['address', 'completed']),
    ];

    track = [];

    constructor(private cacheNativeService: CacheService, private platform: Platform) {
        super();
        this.track = this.originalTracks;
    }
    
    getName(): TrackTypes {
        return TrackTypes.CONTA_ION_ADDRESS;
    }

    getTrack(): TrackInfo[] {
        return this.track;
    }

    public async loadData() {
        // MobileMockData.executeMockCall(500);
        const data = await this.cacheNativeService.getItemCommunicator();
        return Promise.resolve(ContaIonDataParse.parseFromMobileData(data));
    }

    public isUncoupled() {
        return true;
    }

    isEventComunicator() {
        return true;
    }

    public executeAction(actionName, data): TrackActionResult {
        throw new Error('Esta track não possui actions')
    }

    isBackHeader() {
        return this.platform.is('android');
    }

}
